const state = {
  theme: 'default',
  returnFocusElement: null,
  visible: false,
  persistent: false, //- no background clicks
  modalComponent: null,
  stepBackActions: [], //- has to be namespaced e.g addressBook/editAddressModal,
  modalProps: {}
};

export const getters = {

};

export const actions = {
  executeStepBackAction({ commit, dispatch, state }) {
    let action = state.stepBackActions[state.stepBackActions.length - 1];
    if (!action) {
      return;
    }

    dispatch(action, null, { root: true });
    commit('popModalStepBackAction');
  },

  hideModal({ state, commit, dispatch }) {
    //- hide current modal first
    commit('setVisible', false);
    commit('setPersistent', false);
    // timeout resets the theme after .2s to compinsate for css transition
    setTimeout(() => {
      commit('setTheme', 'default');
      if (state.returnFocusElement) {
        state.returnFocusElement.focus();
        commit('setReturnFocus', null);
      }
    }, 200);
    //- only then dispatch back action, it could be a modal that needs visible
    dispatch('executeStepBackAction');
  },

  showModal({ commit }, params) {
    commit('setVisible', true);
    if (params.theme) {
      commit('setTheme', params.theme);
    }
    if (params.props) {
      commit('setModalProps', params.props);
    }
    if (params.returnFocusElement) {
      commit('setReturnFocus', params.returnFocusElement);
    }
    commit('setComponent', params.component);
  },

  showPrompt({ commit, dispatch }, params) {
    commit('setModalProps', params);
    dispatch('showModal', params);
  }
};

export const mutations = {
  setComponent(state, val) {
    state.modalComponent = val;
  },

  setReturnFocus(state, val) {
    state.returnFocusElement = val;
  },

  setVisible(state, val) {
    state.visible = val;
  },

  setTheme(state, val) {
    state.theme = val;
  },

  pushModalStepBackAction(state, val) {
    state.stepBackActions.push(val);
  },

  popModalStepBackAction(state, val) {
    state.stepBackActions.pop(val);
  },

  setModalProps(state, val) {
    state.modalProps = val || {};
  },

  setPersistent(state, val) {
    state.persistent = val || false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
